import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Project } from 'src/app/model/project/project';
import { SubProject } from 'src/app/model/project/sub-project';
import { Adjustment } from 'src/app/model/project/adjustment';
import { ModalService } from 'src/app/services/modal.service';
import { TabsService } from 'src/app/services/tabs.service';
import ProjectHelper from 'src/app/helpers/project-helper';
import DateHelper from 'src/app/helpers/date-helper';
import { SnackService } from 'src/app/services/snack.service';

@Component({
  selector: 'create-view-adjustment',
  templateUrl: './create-view-adjustment.component.html',
  styleUrls: ['./create-view-adjustment.component.scss'],
})
export class CreateViewAdjustmentComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @ViewChild(MatStepper)
  matHorizontalStepper: MatStepper;

  @Input()
  project: Project;

  @Input()
  subProject: SubProject;

  @Output()
  submitProject = new EventEmitter();

  adjustment: Adjustment;

  minPlacementDate: Date;

  init = false;

  constructor(
    private modalService: ModalService,
    private tabsService: TabsService,
    private snackService: SnackService
  ) {
    super();
  }

  ngOnInit() {
    this.adjustment = <Adjustment>this.subProject;
    this.minPlacementDate =
      DateHelper.getMomentBusinessDayMinProjectPlacement().toDate();
    if (this.adjustment.id != null && this.project.id != null) {
      this.adjustment.project = this.project;
    }
    if (this.adjustment.id == null) {
      this.adjustment.status = 'Nieuw';
    }

    this.init = true;
  }

  setWithPlacement(value) {
    this.adjustment.withPlacement = value;
  }

  setPickupInfo(value) {
    this.adjustment.pickup.extraInfoPickup = value;
  }

  cancelProject() {
    this.modalService.confirmDialog(
      'Annuleren',
      'Bent u zeker dat u het indienen van ' +
        this.getFormDisplayDemonstrative() +
        ' ' +
        this.getFormDisplayName() +
        ' wilt annuleren? Opgelet: De reeds ingevulde informatie zal verloren gaan.',
      (b) => {
        if (b) {
          this.tabsService.closeTab(
            this.tabsService.getActiveTab(),
            '/client-corner',
            false
          );
        }
      }
    );
  }

  getFormDisplayName() {
    return ProjectHelper.getFormDisplayNameLowerCase(this.subProject);
  }

  doSubmitProject() {
    if (
      !ProjectHelper.isPlacementEarliestDateValidForClient(
        this.subProject,
        this.minPlacementDate
      )
    ) {
      this.snackService.showError(
        'Gelieve een plaatsingsdatum te kiezen minstens vier werkdagen later dan vandaag'
      );
    } else {
      this.submitProject.emit();
    }
  }

  advanceStepper() {
    this.matHorizontalStepper.next();
    window.scrollTo(0, 0);
  }

  getFormDisplayNameUpperCase() {
    return ProjectHelper.getFormDisplayNameUpperCase(this.subProject);
  }
  getFormDisplayNameLowerCase() {
    return ProjectHelper.getFormDisplayNameLowerCase(this.subProject);
  }
  getFormDisplayArticle() {
    return ProjectHelper.getFormDisplayArticle(this.subProject);
  }
  getFormDisplayDemonstrative() {
    return ProjectHelper.getFormDisplayDemonstrative(this.subProject);
  }
}
